export const ADMINISTRATORS_CONTROLLER_NAME = 'ADMINISTRATORS_CONTROLLER_NAME';
export const USERS_CONTROLLER_NAME = "UsersControllerName";
export const USERS_SETTINGS_CONTROLLER_NAME = "UsersSettingsController";
export const LqbFundedLogsControllerName = "LqbFundedLogsControllerName";
export const ManualImportControllerName = "ManualImportControllerName";
export const BranchControllerName = "BranchControllerName";
export const CalculationsLoggingControllerName = 'loggingController';
export const DirectMailerLogsControllerName = 'directMailerLogsController';
export const CampaignControllerName = 'CampaignControllerName';